module.exports = __webpack_public_path__ + "img/steam-logo-transparent.fc29682f.png";